import { useEffect, useState, useRef, useMemo } from "react";
import "./ViewCourse.scss";
import Headings from "../../components/Headings/Headings";
import BadgeStatus from "../../components/BadgeStatus/BadgeStatus";
import DropdownRead from "../../components/DropdownRead/DropdownRead";
import AuiButton from "../../components/Buttons/Buttons";
import Excel from "../../assets/images/excel.svg";
import { useNavigate, useLocation } from "react-router-dom";
import {
  SessionStatusConstants,
  SessionStatusTypes,
} from "../../utils/constants/session-status-constants";
import {
  downloadUploadedDocument,
  fetchTrainingSessionById,
  getDocumentList,
  getStudentList,
  updateTrainingRequest,
  finalizeRoster,
  uploadDocument,
  generateStudentCertificate,
  approveFeedBackDocument,
  generateEligibleStudentsCertificate,
  promoteUser,
  fetchFeedBackDocuments,
  uploadFacilitatorFeedback,
  sendFeedbackReminder,
  getStudentExportList,
} from "../../services/training-session.service";
import AuiPrimaryPagination from "../../components/AuiDropdown/AuiPagination";
import {
  AdminRoles,
  codeToTextMapper,
  FacilitatorHierarchy,
} from "../../utils/constants/app-constants";
import Modals from "../../components/Modals/Modals";
import { useRBACContext } from "@impelsysinc/react-rbac";
import TableStatus from "../../components/TableStatus/TableStatus";
import MoreOption from "../../components/MoreOptions/MoreOption";
import AuiIcon from "../../components/AuiDropdown/AuiIcon";
import { useDispatch } from "react-redux";
import { showAlert } from "../../store/alertSlice";
import { AuiConfirmationModal } from "../../components/Modals/ModalPopUp";
import config from "../../config";
import TrainingSessionStatusMessage from "./TrainingSessionStatusMessage";
import CommonModal from "../../components/Modals/CommonModal";
import { getTrainerExportList } from "../../services/organization.service";

const ViewCourse = () => {
  const { canAccess } = useRBACContext();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const queryParams = new URLSearchParams(location.search);
  const sessionId = parseInt(queryParams.get("id") ?? "-1");
  const userRole = localStorage.getItem("role") ?? "";
  const [trainingSession, setTrainingSession] = useState<any>(null);
  const [collabOrganisation, setCollabOrganisation] = useState<any[]>([]);
  const [numberOfStudents, setNumberOfStudents] = useState<number | null>(null);
  const [becDate, setBecDate] = useState<Date | null>(null);
  const [becDuration, setBecDuration] = useState<number | string>("");
  const [totDate, setTotDate] = useState<Date | null>(null);
  const [totDuration, setTotDuration] = useState<number | string>("");

  const [isViewLoading, setIsViewLoading] = useState(false);
  const [students, setStudents] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isStudentLoading, setIsStudentLoading] = useState(false);
  const [isCourseTableLoading, setIsCourseTableLoading] = useState(false);
  const [isApproveFeedbackLoading, setIsApproveFeedbackLoading] = useState(false);
  const [isCertificateCertLoading, setIsCertificateCertLoading] = useState(false);
  const [isStudCertificateLoading, setIsStudCertificateLoading] = useState(false);
  const [pagination, setPagination] = useState({
    isFirst: true,
    isLast: false,
    pageNumber: 1,
    pageSize: 10,
    totalItems: 0,
    totalPages: 0,
    rowsperpage: 10,
  });
  const [isConceptDownloadLoading, setIsConceptDownloadLoading] =
    useState(false);
  const [isFeedbackDownloadLoading, setIsFeedbackDownloadLoading] =
    useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [fileDetails, setFileDetails] = useState<any>(null);
  const [selectedInstanceData, setSelectedInstanceData] = useState<any>(null);
  const [selectedStudents, setSelectedStudents] = useState<any[]>([]);
  const [documentIds, setDocumentIds] = useState<number[]>([]);
  const [uploadedFiles, setUploadedFiles] = useState<FileList | null | string>(
    null
  );
  const [refreshKey, setRefreshKey] = useState<number>(0);
  const [areAllStudentsSelected, setAreAllStudentsSelected] = useState(false);
  const [feedBackDocumentList, setFeedBackDocumentList] = useState<any[]>([]);
  const [modals, setModals] = useState<Record<string, boolean>>({});
  const [modalCurrentPage, setModalCurrentPage] = useState(1);
  const [modalPageSize, setModalPageSize] = useState(10);
  const [modalPagination, setModalPagination] = useState({
    isFirst: true,
    isLast: false,
    pageNumber: 1,
    pageSize: 10,
    totalItems: 0,
    totalPages: 0,
    rowsperpage: 10,
  });
  const [selectedUserId, setSelectedUserId] = useState<number | null>(null);
  const pageOrder = "id dsc";
  const [reminderSent, setReminderSent] = useState(false);
  const MAX_CERT_DOWNLOAD = parseInt(config.maxCertificateDownload);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredTrainers, setFilteredTrainers] = useState<any[]>([]);
  const inputRef = useRef<HTMLInputElement>(null);
  const [isStudentTableLoading, setIsStudentTableLoading] = useState(false);

  const hasCourseEditAccess = canAccess({
    action: ["*"],
    resource: "course",
  });
  const hasApproveAccess = canAccess({
    action: ["patch", "post"],
    resource: "courseApproval",
  });
  const canAccessRoster = canAccess({
    action: "*",
    resource: "roster",
  });
  const completionStatusMapper: any = {
    COMPLETED: "GENERATED",
    PENDING: "NOT_GENERATED",
    FAILED: "FAILED"
  }

  const handlePageSizeChange = (newPageSize: number) => {
    setPageSize(newPageSize);
    setCurrentPage(1);
  };

  const handleModalPageSizeChange = (newPageSize: number) => {
    setModalPageSize(newPageSize);
    setModalCurrentPage(1);
  };

  const handleBackButton = () => {
    navigate("/course-listing");
  };

  const isInvalidSessionId = (id: number | string | null) => {
    return isNaN(sessionId) || !/^\d+$/.test(queryParams.get("id") ?? "");
  };
  useEffect(() => {
    if (isInvalidSessionId(sessionId)) {
      navigate("/page-not-found");
      return;
    }
  
    if (sessionId !== -1) {
      fetchSession();
    }
  }, [sessionId]);

  const fetchSession = async () => {
    setIsViewLoading(true);
    const result = await fetchTrainingSessionById(sessionId);
    if (result?.error?.status === 400 || result?.error?.status === 404) {
      navigate(result.error.status === 400 ? "/no-permission" : "/page-not-found");
      return;
    }
    setIsViewLoading(false);
    const session = result.data?.trainingSession;
    setTrainingSession(session);
    setSelectedInstanceData({
      index: 0,
      ...session?.trainingInstance[0],
      isFeedbackApproved:
        (session?.trainingDocument || []).find(
          (document: any) =>
            document?.documentType === "CLASS_FEEDBACK" &&
            document?.trainingInstanceId === session?.trainingInstance?.[0]?.id
        )?.isFeedbackApproved || false,
    });
    const hasClassFeedback = session?.trainingDocument?.some(
      (doc: { documentType: string }) => doc.documentType === "CLASS_FEEDBACK"
    );
    if (hasClassFeedback) {
      fetchUploadedDocuments();
    }
    const conceptNotes = session?.trainingDocument.filter(
      (doc: { documentType: string }) => doc.documentType === "CONCEPT_NOTE"
    );
    if (conceptNotes?.length) {
      setFileDetails(conceptNotes);
    }
    if (!session?.trainingInstance || session.trainingInstance.length === 0) {
      console.error("No training instances found");
      return;
    }
    const [first, second] = session?.trainingInstance || [];

    setNumberOfStudents(first.totalStudent);

    let [datePart] = first.startDate.split("T");
    if (first.trainingTypeCode !== "BEC TOT") {
      setBecDate(new Date(datePart));
      setBecDuration(first.duration);
    } else {
      setTotDate(new Date(datePart));
      setTotDuration(first.duration);
    }

    if (second) {
      [datePart] = second.startDate.split("T");
      setTotDate(new Date(datePart));
      setTotDuration(second.duration);
    }
  };

  const fetchStudents = async () => {
    if (selectedInstanceData == null) {
      return;
    }
    setIsStudentLoading(true);
    setIsStudentTableLoading(true);
    setStudents([]);
    try {
      const studentResponse: any = await getStudentList(
        sessionId,
        currentPage,
        pageSize,
        selectedInstanceData?.id
      );
      if (studentResponse) {
        setStudents(studentResponse?.students || []);
        setPagination({
          isFirst: !!studentResponse.pagination?.isFirst,
          isLast: studentResponse.pagination?.isLast || false,
          totalItems: studentResponse.pagination?.totalCount || 0,
          totalPages: studentResponse.pagination?.totalPages || 0,
          pageNumber: studentResponse.pagination?.pageNumber || 1,
          pageSize: studentResponse.pagination?.pageSize || 10,
          rowsperpage: studentResponse.pagination?.pageSize || 10,
        });
      }
    } catch (error) {
      console.error("Error fetching student list:", error);
      setStudents([]);
    } finally {
      setIsStudentTableLoading(false);
      setIsStudentLoading(false);
    }
  };

  useEffect(() => {
    const attendedStudents = (students || []).filter(
      (filteredStudent: any) =>
        filteredStudent?.trainingDetails?.[0]
          ?.isAttendanceCertificateGenerated
    );
    setAreAllStudentsSelected(
      !!selectedStudents.length &&
        (userRole === AdminRoles.ApprovingAdmin
          ? attendedStudents
          : students || []
        ).every((student: any) => selectedStudents.map(sStudent => sStudent.id).includes(student.id))
    );
  }, [students])

  useEffect(() => {
    fetchStudents();
  }, [currentPage, pageSize]);

  const getTrainerText = (trainerType: any) => {
    if (!trainingSession) {
      return;
    }
    const trainers = trainingSession?.trainingSessionTrainer.filter(
      (trainer: { trainerType: any; }) => trainer.trainerType === trainerType
    );
    const count = trainers.length;
    if (count === 0) {
      return "None";
    } else if (count === 1) {
      return `${trainers[0].firstName} ${trainers[0].lastName}`;
    } else {
      return `${count} selected`;
    }
  };
  useEffect(() => {
    if (!trainingSession) return;
    const matchedOrganisationList = trainingSession.collaboratingOrganisation.map((org: any) => ({
      label: org.organisationName,
      value: org.organisationId.toString(),
    }));

    setCollabOrganisation(matchedOrganisationList);
  }, [trainingSession]);

  function navigateToEdit(): void {
    if (handleStudentNavigation()) {
      navigate(`/create-course/studentDetail?id=${sessionId}`);
    } else {
      navigate(`/create-course/classDetails?id=${sessionId}`);
    }
  }

  useEffect(() => {
    if (selectedInstanceData == null) {
      return;
    }
    setCurrentPage(1);
    setPageSize(10);
    fetchStudents();
  }, [selectedInstanceData]);

  const handleDownload = async () => {
    if (isConceptDownloadLoading || !fileDetails.length) return;
    setIsConceptDownloadLoading(true);
    const latestDocument = fileDetails[fileDetails.length - 1];
    if (latestDocument?.id) {
      const documentId = latestDocument.id;

      await downloadUploadedDocument(sessionId, documentId);
      console.log("Download successful");
    }
    setIsConceptDownloadLoading(false);
  };
  const sendStatusUpdateRequest = async (status: string) => {
    let remarks = "";
    if (status === "REJECTED") {
      const textarea = document.querySelector(
        "aui-textarea#rejectNote",
      ) as HTMLElement & { getCurrentValue: () => Promise<string> };

      remarks = await textarea?.getCurrentValue();
      remarks = remarks?.trim();
      const charCount = remarks?.replace(/\s/g, "").length || 0;
      if (charCount < 10) {
        dispatch(
          showAlert({
            message: "Please enter at least 10 characters.",
            type: "error",
          })
        );
        return;
      }
    }
    const response = await updateTrainingRequest(sessionId, status, remarks);
    if (response.status === 200) {
      const message = `Course has been ${
        status === "APPROVED" ? "approved" : "rejected"
      }!`;
      dispatch(showAlert({ message, type: "success" }));
      if (
        response?.data?.trainerResponse?.message ===
        "reject reason is mandatory field."
      ) {
        return;
      }
      navigate("/course-listing");
    }
  };

  const showEditButton = () => {
    const { trainingTypeCode, trainingInstance, status } =
      trainingSession || {};
    const isEditableStatus = [
      "DRAFT",
      "PENDING",
      "REJECTED",
      "APPROVED",
    ].includes(status);
    const isAllowedRole =
      hasCourseEditAccess || userRole === AdminRoles.MasterTrainer;

    if (!isAllowedRole) return false;

    if (trainingTypeCode === "BEC" || trainingTypeCode === "BEC TOT") {
      return isEditableStatus;
    }

    if (trainingTypeCode === "BEC+BEC TOT") {
      if (["DRAFT", "PENDING", "REJECTED"].includes(status)) {
        return true;
      }

      const selectedInstance = trainingInstance?.find(
        (instance: { id: any }) => instance.id === selectedInstanceData?.id
      );
      if (!selectedInstance) return false;

      return selectedInstance.id === trainingInstance[0]?.id
        ? isEditableStatus
        : trainingInstance[0]?.status === "COMPLETED" &&
            ["DRAFT", "PENDING", "REJECTED", "APPROVED"].includes(
              selectedInstance.status
            );
    }

    return false;
  };
 
  const handleStudentNavigation = () => {
    const trainingTypeCode = trainingSession?.trainingTypeCode;
    const trainingInstance = trainingSession?.trainingInstance;
    const status = trainingSession?.status;

    return (
      (hasCourseEditAccess || userRole === AdminRoles.MasterTrainer) &&
      (["APPROVED"].includes(status) ||
        (trainingTypeCode === "BEC+BEC TOT" &&
          trainingInstance?.some(
            (instance: { status: string }) => instance.status === "APPROVED"
          )))
    );
  };

  const handleFinalizeRoster = async () => {
    setIsViewLoading(true);
    if (selectedInstanceData !== null) {
      const result = await finalizeRoster(selectedInstanceData?.id);
      if (result?.status === 200) {
        setIsViewLoading(false);
        dispatch(
          showAlert({
            message: "Roster finalized successfully!",
            type: "success",
          })
        );
        fetchSession();
      }
    }
  };
  const [first, second] = trainingSession?.trainingInstance || [];
  const currentDate = new Date();
  const currentDateOnly = currentDate.toISOString().split("T")[0];

  // Finalise roster CTA enable/disable
  const becStartDateOnly = first?.startDate
    ? first.startDate.split("T")[0]
    : null;
  const totStartDateOnly = second?.startDate
    ? second.startDate.split("T")[0]
    : null;

  const enableRoster = becStartDateOnly && currentDateOnly >= becStartDateOnly;
  const becTotenableRoster =
    totStartDateOnly && currentDateOnly >= totStartDateOnly;

  // Upload fedback CTA enable/disable
  const becEndDateOnly = first?.endDate?.split("T")[0];
  const totEndDateOnly = second?.endDate?.split("T")[0];

  const enableFeedback = becEndDateOnly && currentDateOnly > becEndDateOnly;
  const becTotenableFeedack =
    totEndDateOnly && currentDateOnly > totEndDateOnly;

  let feedbackBtnEnable = null;
  if (selectedInstanceData?.id === first?.id) {
    feedbackBtnEnable = enableFeedback;
  } else if (selectedInstanceData?.id === second?.id) {
    feedbackBtnEnable = becTotenableFeedack;
  }

  const showFinalizeRosterButton = () => {
    const trainingTypeCode = trainingSession?.trainingTypeCode;
    const status = trainingSession?.status;

    return (
      canAccessRoster &&
      students?.length > 0 &&
      status === "APPROVED" &&
      ["BEC", "BEC TOT"].includes(trainingTypeCode)
    );
  };

  const getInstanceStatus = (status: string) => {
    if (status === "INPROGRESS") {
      return "ROSTERFINALIZED";
    }
    return status;
  };

  const handleStudentSelection = (isSelected: boolean, checkedStudent: any) => {
    const updatedStudentSelections = !isSelected
      ? selectedStudents.filter(
          (student: any) => student.id !== checkedStudent.id
        )
      : [...selectedStudents, checkedStudent];
    setAreAllStudentsSelected(
      (userRole === AdminRoles.ApprovingAdmin
        ? students.filter(
            (student: any) =>
              student?.trainingDetails?.[0]?.isAttendanceCertificateGenerated
          )
        : students
      ).every((student: any) =>
        updatedStudentSelections
          .map((uStudent) => uStudent.id)
          .includes(student.id)
      )
    );
    setSelectedStudents(updatedStudentSelections);
  };

  const handleStudentMultiSelection = (isSelected: boolean) => {
    setAreAllStudentsSelected(isSelected);
    const currentPageStudentIds = students.map((student: any) => student.id);
    if (!isSelected) {
      setSelectedStudents(
        selectedStudents.filter(
          (student: any) => !currentPageStudentIds.includes(student.id)
        )
      );
    } else {
      const studentsToAdd = students.filter((student: any) =>
        userRole === AdminRoles.ApprovingAdmin
          ? student?.trainingDetails?.[0]?.isAttendanceCertificateGenerated
          : true
      );
      const merged = [...selectedStudents, ...studentsToAdd];
      const uniqueStudents = merged.filter(
        (student, index, self) =>
          index === self.findIndex((s) => s.id === student.id)
      );
      setSelectedStudents(uniqueStudents);
    }
  };

  const handleFileChange = (files: FileList | null) => {
    if (files && sessionId !== -1) {
      setUploadedFiles(files);
    } else {
      setUploadedFiles(null);
    }
  };

  const handleFeedbackSubmit = async () => {
    if (uploadedFiles && uploadedFiles.length > 0) {
      try {
        const fileToUpload: any = uploadedFiles[0];
        setIsViewLoading(true);
        const response = await uploadDocument(
          fileToUpload,
          "CLASS FEEDBACK",
          sessionId,
          selectedInstanceData?.id
        );
        setIsViewLoading(false);
        if (
          response.status === 200 &&
          response.data?.trainingDocument?.status === "COMPLETED"
        ) {
          const documentId = response.data.trainingDocument.documentId;
          const updatedDocumentIds = [...documentIds];
          updatedDocumentIds[selectedInstanceData?.index || 0] = documentId;
          setDocumentIds(updatedDocumentIds);
          fetchSession();
        }
      } catch (error) {
        setIsViewLoading(false);
        console.error("Upload failed:", error);
      }
    } else {
      console.error("No file selected for upload.");
    }
  };

  const handleFeedbackDownload = async () => {
    if (isFeedbackDownloadLoading) return;
    setIsFeedbackDownloadLoading(true);
    if (documentIds[selectedInstanceData?.index]) {
      await downloadUploadedDocument(
        sessionId,
        documentIds[selectedInstanceData?.index],
        selectedInstanceData?.id
      );
      setIsFeedbackDownloadLoading(false);
    }
  };

  const fetchUploadedDocuments = async () => {
    const response = await getDocumentList(
      sessionId,
      "CLASS FEEDBACK"
    );
    if (response?.data?.trainingInstances.length > 0) {
      setDocumentIds(
        response.data.trainingInstances.map((instance: any) => instance.id)
      );
    }
  };

  const getFeedbackTemplate = async () => {
    if (!selectedInstanceData) return;

    await downloadUploadedDocument(
      selectedInstanceData.trainingSessionId,
      0,
      selectedInstanceData.id,
      "CLASS FEEDBACK"
    )
  }

  const getTrainingStatus = () => {
    const isAdminRole = [
      AdminRoles.SponsoringAdmin,
      AdminRoles.MasterTrainer,
    ].includes(userRole as AdminRoles);

    const isApprovingAdmin = [AdminRoles.ApprovingAdmin].includes(
      userRole as AdminRoles
    );

    const isBECOrBECTOT = ["BEC", "BEC TOT"].includes(
      trainingSession?.trainingTypeCode
    );

    if (isAdminRole) {
      if (isBECOrBECTOT) {
        return getBECTrainingStatus();
      }
      if (trainingSession?.trainingTypeCode === "BEC+BEC TOT") {
        return getBECTOTTrainingStatus();
      }
    }

    // Approving admin role logic
    if (isApprovingAdmin) {
      if (isBECOrBECTOT) {
        return trainingSession?.status;
      }

      if (trainingSession?.trainingTypeCode === "BEC+BEC TOT") {
        return handleBECTOTStatus();
      }
    }
    return null;
  };

  const handleBECTOTStatus = () => {
    const feedbackDocuments =
      trainingSession?.trainingDocument?.filter(
        (doc: { documentType: string }) =>
          doc?.documentType === "CLASS_FEEDBACK"
      ) || [];

    const becInstance = trainingSession?.trainingInstance?.[0];
    const totInstance = trainingSession?.trainingInstance?.[1];

    if (
      becInstance?.status === "INPROGRESS" &&
      becInstance?.feedBackMessage !== ""
    ) {
      SessionStatusConstants.INPROGRESSBECINSTANCE.statusInfo[
        "Approving Org Admin"
      ][0] = becInstance?.feedBackMessage?.replace("Send Reminder", "");
      return "INPROGRESSBECINSTANCE";
    }

    if (
      becInstance?.status === "COMPLETED" &&
      totInstance?.feedBackMessage !== ""
    ) {
      SessionStatusConstants.INPROGRESSTOTINSTANCE.statusInfo[
        "Approving Org Admin"
      ][1] = totInstance?.feedBackMessage?.replace("Send Reminder", "");
      return "INPROGRESSTOTINSTANCE";
    }
    
    if (becInstance?.status !== "COMPLETED") {
      return becInstance?.status;
    }

    if (
      becInstance.status === "COMPLETED" &&
      totInstance.status === "COMPLETED"
    ) {
      return "COMPLETEDBECTOT";
    }

    if (
      becInstance?.status === "COMPLETED" &&
      feedbackDocuments[0]?.isFeedbackApproved &&
      feedbackDocuments.length === 1
    ) {
      return "INPROGRESSBECTOT";
    }

    return totInstance?.status;
  };

  const getBECTrainingStatus = () => {
    if (trainingSession?.status === "APPROVED" && !enableRoster) {
      return "ROSTERNOTFINLIASED";
    }

    const hasClassFeedback =
      trainingSession?.trainingDocument?.some(
        (document: { documentType: string }) =>
          document?.documentType === "CLASS_FEEDBACK"
      ) && documentIds[selectedInstanceData?.index];

    if (trainingSession?.status === "INPROGRESS") {
      if (!enableFeedback) {
        return "FEEDBACKNOTUPLOADED";
      }

      if (hasClassFeedback && !selectedInstanceData?.isFeedbackApproved) {
        return "FEEDBACKNOTAPPROVED";
      }
    }

    return trainingSession?.status;
  };

  const getBECTOTTrainingStatus = () => {
    const [becInstance, totInstance] = trainingSession?.trainingInstance || [];
    const { status: becStatus, trainingTypeCode: typeBEC, feedbackReminderMessage: becFeedbackMessage } = becInstance || {};
    const { status: totStatus, trainingTypeCode: typeTOT, feedbackReminderMessage: totFeedbackMessage } = totInstance || {};

    const rosterStatus = getRosterStatus(becStatus, totStatus, enableRoster, becTotenableRoster);
    if (rosterStatus) return rosterStatus;

    const feedbackDocuments =
      trainingSession?.trainingDocument?.filter(
        (doc: { documentType: string }) =>
          doc?.documentType === "CLASS_FEEDBACK"
      ) || [];

    if (
      becStatus === "COMPLETED" &&
      totStatus === "INPROGRESS" &&
      feedbackDocuments.length === 2 &&
      feedbackDocuments.some(
        (doc: { isFeedbackApproved: any }) => !doc?.isFeedbackApproved
      )
    ) {
      return "FEEDBACKNOTAPPROVEDTOTINSTANCE";
    }

    const feedbackReminderStatus = getFeedbackReminderStatus(becStatus,totStatus,becFeedbackMessage,totFeedbackMessage,reminderSent);
    if (feedbackReminderStatus) return feedbackReminderStatus;

    const totStudentStatus = getTotStudentStatus(becStatus,totStatus,totInstance,becTotenableFeedack);
    if (totStudentStatus) return totStudentStatus;

    // Feedback can not be uploaded before course end for BEC/TOT
    const feedbackUploadStatus = getFeedbackUploadStatus(becStatus,totStatus,enableFeedback,becTotenableFeedack);
    if (feedbackUploadStatus) return feedbackUploadStatus;

    //Check if feedback is approved or not
    const feedbackApprovalStatus = getFeedbackApprovalStatus(typeBEC, typeTOT, feedbackDocuments);
    if (feedbackApprovalStatus) return feedbackApprovalStatus;

    //Other status
    if (trainingSession?.trainingTypeCode === "BEC+BEC TOT") {
      return becStatus !== "COMPLETED" ? becStatus : totStatus;
    }
  };

  const checkApprovedInstance = () => {
    const { trainingTypeCode, trainingInstance } = trainingSession || {};

    if (trainingTypeCode === "BEC+BEC TOT") {
      return trainingInstance?.[0]?.status !== "COMPLETED"
        ? trainingInstance?.[0]?.trainingTypeCode
        : trainingInstance?.[1]?.trainingTypeCode;
    }
  };

  const fetchAttendanceCertificate = async (type: string) => {
    if (selectedStudents.length > MAX_CERT_DOWNLOAD) {
      dispatch(
        showAlert({
          message: `You can only download up to ${MAX_CERT_DOWNLOAD} certificates`,
          type: "error",
        })
      );
      return;
    }
    setIsStudentLoading(true);
  try {
    const studentIds =
      type === "Cert_A"
        ? selectedStudents.map((student) => student.id)
        : selectedStudents
            .filter(
              (student) =>
                student?.trainingDetails[0]?.completionCertificateGeneratedStatus === "COMPLETED"
            )
            .map((filteredStudent) => filteredStudent.id);
    const allFailed = selectedStudents.every(
       (student) => student?.trainingDetails[0]?.completionCertificateGeneratedStatus === "FAILED"
    );
    if (type === "Cert_C" && allFailed) {
      dispatch(
      showAlert({
         message: "You are not eligible to download the certificate as the student did not pass the course",
         type: "error",
         })
        );
        setIsStudentLoading(false);
      return;
     }                   
    if (type === "Cert_C" && !studentIds.length) {
      dispatch(
        showAlert({
          message:
            "No students have completion certificate generated yet. Please generate them first.",
          type: "info",
        })
      );
      setSelectedStudents(() => []);
      setIsStudentLoading(false);
      setAreAllStudentsSelected(false);
      return;
    }        
    const response: any = await generateStudentCertificate(
      studentIds,
      selectedInstanceData?.id,
      type
    );
    if (!response?.error) {
      if (type === "Cert_C") {
        dispatch(
          showAlert({
            message:
              "The generated certificate(s) of completion have been downloaded successfully",
            type: "success",
          })
        );
      }
      await new Promise((resolve) => setTimeout(resolve, 2000));
      setSelectedStudents(() => []);
      fetchStudents();
    } else {
      setIsLoading(false);
    }
  } finally {
    setIsStudentLoading(false);
  }
  };

  const resetFileUploadState = () => {
    setUploadedFiles(null);
    setRefreshKey((prevKey) => prevKey + 1);
  };

  const approveFeedback = async () => {
    setIsApproveFeedbackLoading(true);
    const response = await approveFeedBackDocument(
      documentIds[selectedInstanceData?.index || 0],
      sessionId,
      selectedInstanceData?.id,
      { isFeedbackApproved: true }
    );
    setIsApproveFeedbackLoading(false);
    if (response?.status === 200) {
      dispatch(
        showAlert({
          message: "Course coordinator workbook approved successfully!",
          type: "success",
        })
      );
      fetchSession();
    }
  };

  const markEligibleStudents = async (status: string) => {
    if (!selectedStudents.length || isCertificateCertLoading) {
      return;
    }
    if (status == "COMPLETED") {
      setIsCertificateCertLoading(true);
    }
    if (status == "FAILED") {
      setIsStudCertificateLoading(true);
    }
    try {
      const response = await generateEligibleStudentsCertificate(
        sessionId,
        selectedInstanceData?.id,
        selectedStudents.map((student) => student.id),
        status
      );
      if (response?.status === 200) {
        setSelectedStudents([]);
        fetchStudents();
      }
    } finally {
      setIsCertificateCertLoading(false);
      setIsStudCertificateLoading(false);
    }
  };

  const promoteTrainer = async (id: number, currentRole: string) => {
    const backendRole =
      codeToTextMapper[currentRole]?.toUpperCase() || currentRole;
    if (currentRole === "MASTER TRAINER") return;
    const response = await promoteUser(id, sessionId, backendRole);
    if (response.status === 200) {
      const successMessage = response.data.promotion;
      dispatch(showAlert({ message: successMessage, type: "success" }));
    }
    fetchSession();
  };

  const handleResetNoteModal = () => {
    setRefreshKey((prevKey) => prevKey + 1);
  };

  const handleResetDocumentModal = () => {
    setRefreshKey((prevKey) => prevKey + 1);
    setModalCurrentPage(1);
    setModalPageSize(10);
  };

  const handleUploadDocument = (userId: string) => {
    setModals((prevModals) => ({
      ...prevModals,
      [userId]: true,
    }));
  };

  const handleCancelUploadDoc = (userId: string) => {
    setModals((prevModals) => ({
      ...prevModals,
      [userId]: false,
    }));
  };

  const fetchFeedbackDocumentList = async (
    userId: any,
    pageNumber: number,
    pageSize: number,
    pageOrder: any
  ) => {
    setFeedBackDocumentList([]);
    setIsLoading(true);
    const response = await fetchFeedBackDocuments({
      userId,
      documentType: "FACILITATOR FEEDBACK",
      pageNumber,
      pageSize,
      pageOrder,
    });
    const userDocumentsList = response?.data?.userDocuments;
    setFeedBackDocumentList(userDocumentsList);
    setIsLoading(false);
    setModalPagination({
      isFirst: !!response._pagination?.isFirst || false,
      isLast: response._pagination?.isLast || false,
      totalItems: response._pagination?.totalCount || 0,
      totalPages: response._pagination?.totalPages || 0,
      pageNumber: response._pagination?.pageNumber || 1,
      pageSize: response._pagination?.pageSize || 10,
      rowsperpage: response._pagination?.pageSize || 10,
    });
  };

  const displayFeedbackDocumentList = (userId: any) => {
    setSelectedUserId(userId);
    setModalCurrentPage(1);
    fetchFeedbackDocumentList(
      userId,
      modalCurrentPage,
      modalPageSize,
      pageOrder
    );
  };

  const getRosterStatus = (
      becStatus?: string,
      totStatus?: string,
      enableRoster?: boolean,
      becTotenableRoster?: boolean
    ): string | undefined => {
    if (
      becStatus === "APPROVED" &&
      totStatus === "APPROVED" &&
      !enableRoster
    ) {
      return "ROSTERNOTFINLIASEDBECINSTANCE";
    }
    //Roster can not be finalized before course start for BEC/TOT
    if (becStatus === "APPROVED" && !enableRoster) {
      return "ROSTERNOTFINLIASEDBECTOT";
    }

    if (
      becStatus === "COMPLETED" &&
      totStatus === "APPROVED" &&
      !becTotenableRoster
    ) {
      return "ROSTERNOTFINLIASEDBECTOT";
    }
    return undefined;
  };

  const getFeedbackApprovalStatus = (
    typeBEC?: string,
    typeTOT?: string,
    feedbackDocuments:  { isFeedbackApproved?: boolean }[] = []
    ): string | undefined => {

    if (
      typeBEC === "BEC" &&
      feedbackDocuments.length === 1 &&
      !feedbackDocuments[0]?.isFeedbackApproved
    ) {
      return "FEEDBACKNOTAPPROVED";
    }

    if (
      typeTOT === "BEC TOT" &&
      feedbackDocuments.length === 2 &&
      feedbackDocuments.some((doc) => !doc?.isFeedbackApproved)
    ) {
      return "FEEDBACKNOTAPPROVED";
    }
      return undefined;
  };

  const getFeedbackUploadStatus = (
      becStatus?: string,
      totStatus?: string,
      enableFeedback?: boolean,
      becTotenableFeedack?: boolean
    ): string | undefined => {

    if (becStatus === "INPROGRESS" && !enableFeedback) {
      return "FEEDBACKNOTUPLOADEDBECTOT";
    }

    if (
      becStatus === "COMPLETED" &&
      totStatus === "INPROGRESS" &&
      !becTotenableFeedack
    ) {
      return "FEEDBACKNOTUPLOADEDBECTOT";
    }
      return undefined;
  };

  const getTotStudentStatus = (
    becStatus?: string,
    totStatus?: string,
    totInstance?: { isRoasterFinalised?: boolean },
    becTotenableFeedack?: boolean
  ): string | undefined => {
    if (becStatus !== "COMPLETED") return undefined;

    if (totStatus === "APPROVED" && !totInstance?.isRoasterFinalised) {
      return "TOTSTUDENTNOTADDED";
    }

    if (totStatus === "INPROGRESS" && totInstance?.isRoasterFinalised) {
      return !becTotenableFeedack
        ? "FEEDBACKNOTUPLOADEDTOTINSTANCE"
        : "TOTSTUDENTADDED";
    }

    return undefined;
  };


  const getFeedbackReminderStatus = (
    becStatus?: string,
    totStatus?: string,
    becFeedbackMessage?: string,
    totFeedbackMessage?: string,
    reminderSent?: boolean
  ): string | undefined => {

  if (
    becStatus === "INPROGRESS" &&
    totStatus === "APPROVED" &&
    !reminderSent &&
    becFeedbackMessage !== ""
  ) {
    SessionStatusConstants.FEEDBACKREMINDERBECINSTANCE.statusInfo["Sponsoring Org Admin"][0] = becFeedbackMessage;
    SessionStatusConstants.FEEDBACKREMINDERBECINSTANCE.statusInfo["Master Trainer"][0] = becFeedbackMessage;
    return "FEEDBACKREMINDERBECINSTANCE";
  }

  if (
    becStatus === "COMPLETED" &&
    totStatus === "INPROGRESS" &&
    !reminderSent &&
    totFeedbackMessage !== ""
  ) {
    SessionStatusConstants.FEEDBACKREMINDERTOTINSTANCE.statusInfo["Sponsoring Org Admin"][1] = totFeedbackMessage;
    SessionStatusConstants.FEEDBACKREMINDERTOTINSTANCE.statusInfo["Master Trainer"][1] = totFeedbackMessage;
    return "FEEDBACKREMINDERTOTINSTANCE";
  }

  return undefined;
  };


  useEffect(() => {
    if (selectedUserId) {
      fetchFeedbackDocumentList(
        selectedUserId,
        modalCurrentPage,
        modalPageSize,
        pageOrder
      );
    }
  }, [modalCurrentPage, modalPageSize]);

  const downloadFeedbackDocument = (documentUrl: string, fileName: string) => {
    if (!documentUrl) {
      return;
    }

    const link = document.createElement("a");
    link.setAttribute("href", documentUrl);
    link.setAttribute("download", fileName);
    link.setAttribute("target", "_self");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  
  const formatDocCreatedDate = (dateString: string): string => {
    const date = new Date(dateString);
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${month}-${day}-${year}`;
  };
  
  const facilitatorFeedbackUpload = async (userId: any) => {
    setIsLoading(true);
    setIsCourseTableLoading(true);
    if (uploadedFiles && uploadedFiles.length > 0) {
      const fileToUpload = uploadedFiles[0];
      const response = await uploadFacilitatorFeedback(
        userId,
        "FACILITATOR FEEDBACK",
        fileToUpload
      );
      if (response?.status === 200) {
        setIsCourseTableLoading(false);
        setTimeout(() => {
          dispatch(
            showAlert({
              message: "Facilitator feedback document uploaded successfully!",
              type: "success",
            })
          );
        }, 1000);
      }
      setModals((prevModals) => ({
        ...prevModals,
        [userId]: false,
      }));
      fetchSession();
    }
  };

  const isApprovalRole = [AdminRoles.ApprovingAdmin].includes(
    userRole as AdminRoles
  );
  const selectedInstance = trainingSession?.trainingInstance?.find(
    (instance: { id: any }) => instance.id === selectedInstanceData.id
  );
  const instances = trainingSession?.trainingInstance || [];
  const firstInstance = instances?.[0];
  const secondInstance = instances?.[1];

  const showSendReminder = () => {
    if (!isApprovalRole) {
      return false;
    }
    if (instances.length === 1) {
      return firstInstance?.feedBackMessage
    }
    if (
      firstInstance?.status === "INPROGRESS" &&
      secondInstance?.status === "APPROVED" &&
      firstInstance?.feedBackMessage !== ""
    ) {
      return true;
    }
    if (
      firstInstance?.status === "COMPLETED" &&
      secondInstance?.status === "INPROGRESS" &&
      secondInstance?.feedBackMessage !== ""
    ) {
      return true;
    }
    return false;
  };

  const handleSendReminder = async () => {
    setIsLoading(true);
    const response = await sendFeedbackReminder(selectedInstance.id);    
    if (response?.status === 200) {
      setReminderSent(true);
      setIsLoading(false);
      const message = response?.data?.reminder;
      dispatch(
        showAlert({
          message: message,
          type: "success",
        })
      );
    }
    fetchSession();
  };

  useEffect(() => {
  }, [reminderSent]);

  const renderClassDetails = () => {
    return (
      <div className="border-bottom mb-3">
        <fieldset className="row mb-4" aria-labelledby="classInfo">
          <div className="col-sm-12">
            <div className="classDetail py-1">
              <Headings
                className="blue"
                defaultClass="h8"
                size="h2"
                id="classInfo"
              >
                Class Details
              </Headings>
            </div>
          </div>

          <div className="col-sm-12 badgeStatusSection">
            <BadgeStatus
              data={trainingSession?.status}
              infoMessage={
                <TrainingSessionStatusMessage
                  trainingSession={trainingSession}
                  userRole={userRole}
                  getTrainingStatus={getTrainingStatus}
                  replacePlaceholders={replacePlaceholders}
                  handleInProgressStatus={handleInProgressStatus}
                  hasFeedbackReminderMessage={hasFeedbackReminderMessage}
                  getFeedbackReminderMessage={getFeedbackReminderMessage}
                  showSendReminder={showSendReminder}
                  handleSendReminder={handleSendReminder}
                />
              }
              type="others"
              size="small"
              className="mb-4 customBadge"
              reminder={false}
            >
              {showEditButton() && (
                <>
                  <button className="viewEditBtn" onClick={navigateToEdit}>
                    Edit
                  </button>
                  <aui-icon
                    icon="editsquare"
                    svgclass=""
                    svgwidth="15"
                    svgheight="15"
                    pathclass=""
                  ></aui-icon>
                </>
              )}
            </BadgeStatus>
          </div>

          {trainingSession?.status === "REJECTED" && (
            <div className="col-12 rejectNoteText">
              <h3 className="headings h8 font-500 mb-3">Reviewer Note</h3>
              <p className="font-400 h8 border-bottom pb-3 mb-4">
                {trainingSession?.remarks}
              </p>
            </div>
          )}

          <div className="col-md-4 mb-4">
            <p className="h8 font-500 mb-0">Course Type</p>
            <p>{trainingSession?.trainingTypeCode}</p>
          </div>
          <div className="col-md-4 mb-4">
            <p className="h8 font-500 mb-0">Class Type</p>
            <p>{trainingSession?.isHybrid ? "Hybrid" : "Classic"}</p>
          </div>
          <div className="col-md-4 mb-4">
            <p className="h8 font-500 mb-0">Master Trainer</p>
            <p>{getTrainerText("MASTER_TRAINER") ?? "-"}</p>
          </div>
          <div className="col-md-4 mb-4">
            <p className="h8 font-500 mb-0">Registered Facilator/s</p>
            <p>{getTrainerText("REGISTERED_FACILITATOR") ?? "-"}</p>
          </div>
          <div className="col-md-4 mb-4">
            <p className="h8 font-500 mb-0">Provisional Facilator/s</p>
            <p>{getTrainerText("PROVISIONAL_FACILITATOR") ?? "-"}</p>
          </div>
          <div className="col-md-4 mb-4">
            <p className="h8 font-500 mb-0">Number of Students</p>
            <p>{numberOfStudents}</p>
          </div>
        </fieldset>
      </div>
    );
  };
  const renderFileDetails = () => {
    if (!fileDetails) return null;

    return (
      <div className="border-bottom">
        <div className="row d-flex align-items-center">
          <div className="col-sm-4 pb-4">
            <div>
              <Headings
                className={`blue`}
                defaultClass="h8"
                size="h2"
                id="classInfo"
              >
                Documents
              </Headings>
              <p className="font-500 h8">Concept Note</p>
              {isConceptDownloadLoading ? (
                <aui-button
                  buttontitle="Download"
                  variant="secondary"
                  loading
                  size="medium"
                  buttonclass="custBtn py-2"
                />
              ) : (
                <button
                  className="custBtn py-2 mb-4"
                  onClick={handleDownload}
                >
                  <AuiIcon iconClass="download" />
                  <span>Download</span>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };
  const renderLocationDetails = () => (
    <div className="border-bottom my-3">
      <Headings
        className={`blue`}
        defaultClass="h8"
        size="h2"
        id="classInfo"
      >
        Location Details
      </Headings>
      <div className="row d-flex align-items-center">
        <div className="col-sm-4 pb-4">
          <p className="h8 font-500">Country</p>
          <p>{trainingSession?.sessionGeography?.country?.name}</p>
        </div>
        <div className="col-sm-4 pb-4">
          <p className="h8 font-500">Region</p>
          <p>{trainingSession?.sessionGeography?.region?.name}</p>
        </div>
        <div className="col-sm-4 pb-4">
          <p className="h8 font-500">State</p>
          <p>{trainingSession?.sessionGeography?.state?.name}</p>
        </div>
        <div className="col-sm-4 pb-3">
          <p className="h8 font-500">City</p>
          <p>{trainingSession?.sessionGeography?.city}</p>
        </div>
      </div>
    </div>
  );
  const renderCollaborationDetails = () => (
    collabOrganisation.length > 0 && (
      <div>
        <div className="d-flex">
          <aui-checkbox
            checkboxid="primary-checkbox"
            label=""
            disabled={true}
          ></aui-checkbox>
          <Headings
            className="blue mb-0"
            defaultClass="h8"
            size="h2"
            id={`classInfo`}
          >
            In Collaboration Class
          </Headings>
        </div>
        <p className="py-3 collabOrgTitles">
          {collabOrganisation.map((org) => org.label).join(", ")}
        </p>
      </div>
    )
  );
  const renderClassTypeToggle = () => {
    if (
      trainingSession?.trainingTypeCode === "BEC+BEC TOT" &&
      trainingSession?.trainingInstance.length > 1
    ) {
      const handleToggle = (index: number) => {
        setSelectedInstanceData({
          index,
          ...trainingSession?.trainingInstance[index],
          isFeedbackApproved:
            (trainingSession?.trainingDocument || []).find(
              (document: any) =>
                document?.documentType === "CLASS_FEEDBACK" &&
                document?.trainingInstanceId ===
                  trainingSession?.trainingInstance?.[index]?.id
            )?.isFeedbackApproved || false,
        });
        setSelectedStudents([]);
      };

      return (
        <div className="classTypes py-2">
          <ul>
            <li>
              <button
                className={
                  selectedInstanceData?.id ===
                  trainingSession?.trainingInstance[0].id
                    ? "active"
                    : ""
                }
                onClick={() => handleToggle(0)}
              >
                BEC
              </button>
            </li>
            <li>
              <button
                className={
                  selectedInstanceData?.id ===
                  trainingSession?.trainingInstance[1].id
                    ? "active"
                    : ""
                }
                onClick={() => handleToggle(1)}
              >
                BEC TOT
              </button>
            </li>
          </ul>
        </div>
      );
    }

    return null;  
  };
  const renderBECClassInfo = () => {
    const isBEC =
      trainingSession?.trainingTypeCode === "" ||
      trainingSession?.trainingTypeCode === "BEC" ||
      (trainingSession?.trainingTypeCode === "BEC+BEC TOT" &&
        selectedInstanceData?.id ===
          trainingSession?.trainingInstance[0]?.id);

    if (!isBEC) return null;

    return (
      <div className="bordered mb-4">
        <fieldset 
          className="row mt-3 mb-4" 
          aria-labelledby="classInfo"
        >
          <div className="col-sm-12 mb-3">
            <div className="row">
              <div className="col-sm-9 py-2 d-flex align-items-center mb-3">
                <Headings
                  className="blue"
                  defaultClass="h8"
                  size="h2"
                  id={`classInfo`}
                >
                  BEC Class Information
                </Headings>
                {trainingSession?.trainingTypeCode === "BEC+BEC TOT" && (
                  <div className="ml-3 mb-3">
                    <TableStatus
                      status={
                        getInstanceStatus(
                          trainingSession?.trainingInstance[0]?.status
                        ) as SessionStatusTypes
                      }
                    ></TableStatus>
                  </div>
                )}
              </div>

              {canAccessRoster &&
                students?.length > 0 &&
                trainingSession?.trainingTypeCode === "BEC+BEC TOT" &&
                trainingSession?.trainingInstance[0]?.status === "APPROVED" && (
                  <div className="col-sm-3 py-2 d-flex justify-content-end">
                    <Modals
                      modalButtonTitle="Finalize Roster"
                      modalsize="auimodal-sm"
                      headingAlign="center"
                      modalTitle="Finalize Student Roster"
                      footerAlign="right"
                      buttonTitle="Finalize Roster"
                      modalid="finalizeRosterModal"
                      variant="primary"
                      action={() => handleFinalizeRoster()}
                      disableActionButton={!enableRoster}
                    >
                      <p className="text-center font-400 h8 pb-2">
                        NOTE: Once the roster is finalized, you cannot edit any
                        students details.
                      </p>
                    </Modals>
                  </div>
                )}
            </div>
          </div>

          <div className="col-md-4">
            <DropdownRead
              label="Start Date (UTC)"
              value={
                becDate
                  ? `${String(becDate.getUTCMonth() + 1).padStart(2, "0")}-${String(
                      becDate.getUTCDate()
                    ).padStart(2, "0")}-${becDate.getUTCFullYear()}`
                  : "Date not available"
              }
            ></DropdownRead>
          </div>

          <div className="col-md-4">
            <DropdownRead
              label="Duration in Days"
              value={becDuration}
            ></DropdownRead>
          </div>

          {!!documentIds[selectedInstanceData?.index] && (
            <div className="col-sm-12 mt-4 pb-3">
              <p className="font-500 h8">Course coordinator workbook</p>
              {isFeedbackDownloadLoading ? (
                <aui-button
                  buttontitle="Download"
                  variant="secondary"
                  loading
                  size="medium"
                  buttonclass="custBtn py-2"
                ></aui-button>
              ) : (
                <button
                  className="custBtn py-2"
                  onClick={handleFeedbackDownload}
                >
                  <AuiIcon iconClass="download" />
                  <span>Download</span>
                </button>
              )}
            </div>
          )}
        </fieldset>
      </div>
    );
  };
  const renderBECTOTClassInfo = () => {
    const isBECTOT =
      trainingSession?.trainingTypeCode === "BEC TOT" ||
      (trainingSession?.trainingTypeCode === "BEC+BEC TOT" &&
        selectedInstanceData?.id === trainingSession?.trainingInstance[1]?.id);

    if (!isBECTOT) return null;

    const showFinalizeRoster =
      canAccessRoster &&
      students?.length > 0 &&
      trainingSession?.trainingTypeCode === "BEC+BEC TOT" &&
      trainingSession?.trainingInstance[1]?.status === "APPROVED" &&
      trainingSession?.trainingInstance[0]?.status === "COMPLETED";

    return (
      <div className="bordered mb-4">
        <fieldset className="row mt-3 mb-4" aria-labelledby="classInfo">
          <div className="col-sm-9 py-2 d-flex align-items-center mb-3">
            <Headings
              className="blue"
              defaultClass="h8"
              size="h2"
              id={`classInfo`}
            >
              BEC TOT Class Information
            </Headings>
            {trainingSession?.trainingTypeCode === "BEC+BEC TOT" && (
              <div className="ml-3 mb-2">
                <TableStatus
                  status={
                    getInstanceStatus(
                      trainingSession?.trainingInstance[1]?.status
                    ) as SessionStatusTypes
                  }
                />
              </div>
            )}
          </div>

          {showFinalizeRoster && (
            <div className="col-sm-3 py-2 d-flex justify-content-end">
              <Modals
                modalButtonTitle="Finalize Roster"
                modalsize="auimodal-sm"
                headingAlign="center"
                modalTitle="Finalize Student Roster"
                footerAlign="right"
                buttonTitle="Finalize Roster"
                modalid="finalizeRosterModal"
                variant="primary"
                action={handleFinalizeRoster}
                disableActionButton={!becTotenableRoster}
              >
                <p className="text-center font-400 h8 pb-2">
                  NOTE: Once the roster is finalized, you cannot edit any student
                  details.
                </p>
              </Modals>
            </div>
          )}

          <div className="col-md-4">
            <DropdownRead
              label="Start Date (UTC)"
              value={
                totDate
                  ? `${String(totDate.getUTCMonth() + 1).padStart(2, "0")}-${String(
                      totDate.getUTCDate()
                    ).padStart(2, "0")}-${totDate.getUTCFullYear()}`
                  : "Date not available"
              }
            />
          </div>

          <div className="col-md-4">
            <DropdownRead label="Duration in Days" value={totDuration} />
          </div>

          {!!documentIds[selectedInstanceData?.index] && (
            <div className="col-sm-12 mt-4 pb-3">
              <p className="font-500 h8">Course coordinator workbook</p>
              {isFeedbackDownloadLoading ? (
                <aui-button
                  buttontitle="Download"
                  variant="secondary"
                  loading
                  size="medium"
                  buttonclass="custBtn py-2"
                ></aui-button>
              ) : (
                <button
                  className="custBtn py-2 mb-4"
                  onClick={handleFeedbackDownload}
                >
                  <AuiIcon iconClass="download" />
                  <span>Download</span>
                </button>
              )}
            </div>
          )}
        </fieldset>
      </div>
    );
  };
  const renderStudentDetails = () => {
    if (!pagination || pagination.totalItems <= 0) return null;

    const showCheckboxColumn =
      (([AdminRoles.SponsoringAdmin, AdminRoles.MasterTrainer].includes(
        userRole as AdminRoles
      ) &&
        ["INPROGRESS", "COMPLETED"].includes(selectedInstanceData?.status)) ||
        (userRole === AdminRoles.ApprovingAdmin &&
          selectedInstanceData?.status === "COMPLETED"));

    const showAttendanceColumn = ["INPROGRESS", "COMPLETED"].includes(
      selectedInstanceData?.status
    );

    const showCompletionColumn = selectedInstanceData?.status === "COMPLETED";

    const showAttendanceActions =
      [AdminRoles.SponsoringAdmin, AdminRoles.MasterTrainer].includes(
        userRole as AdminRoles
      ) && showAttendanceColumn;

    const showApprovingAdminActions =
      userRole === AdminRoles.ApprovingAdmin &&
      selectedInstanceData?.status === "COMPLETED";

    return (
      <fieldset className="row mb-5" aria-labelledby="students">
        <div className="col-sm-12 py-3">
          <div className="borderWrapped">
            <div className="d-flex flex-column flex-xl-row justify-content-between align-items-left align-items-xl-center py-3">
              <div className="iconsColors">
                <Headings
                  size="h2"
                  defaultClass="h8"
                  className={`blue mb-xl-0`}
                  id="students"
                >
                  <aui-icon
                    svgclass="aui-icon-users"
                    pathclass="aui-path-users"
                    icon="users"
                    svgwidth="25"
                    svgheight="25"
                  ></aui-icon>{" "}
                  Student Details
                </Headings>
              </div>
            </div>

            <section className="sort-item row position-relative mb-2">
              <div className="col-12 d-flex align-items-center justify-content-between">
                {students.length > 0 && (
                  <label className="item-count">
                    Showing {(currentPage - 1) * pageSize + 1} to{" "}
                    {Math.min(currentPage * pageSize, pagination.totalItems)}{" "}
                    items out of {pagination.totalItems}
                  </label>
                )}
                {trainingSession?.status === "COMPLETED" &&
                  students.length > 0 && (
                    <div className="export d-flex align-items-center gap-1 flex-shrink-0 position-relative mb-2">
                      <aui-icon
                        block={true}
                        svgclass="aui-icon-export"
                        pathclass="aui-path-export"
                        icon="export"
                        svgwidth="20"
                        svgheight="20"
                      />
                      <button
                        type="button"
                        className="export-text export-btn"
                        onClick={exportStudent}
                      >
                        Export
                      </button>
                      <button className="tooltip border-0 p-0">
                        <aui-icon
                          svgclass="aui-icon-info"
                          pathclass="aui-path-info"
                          icon="info"
                          svgwidth="18"
                          svgheight="18"
                        />
                        <span className="tooltiptext">
                          The export will include all data, along with
                          additional fields.
                        </span>
                      </button>
                    </div>
                  )}
              </div>
            </section>

            <div className="form-group form-check d-block d-lg-none d-flex align-items-center mt-2">
              {students.map((student: any, index: number) => (
                <input
                  key={student.id || index}
                  type="checkbox"
                  id="primary-checkbox"
                  checked={areAllStudentsSelected}
                  onChange={(event: any) =>
                    handleStudentMultiSelection(event.target.checked)
                  }
                  disabled={isAllDisabled}
                />
              ))}
              <label htmlFor="primary-checkbox" className="select-all-label">
                Select All
              </label>
            </div>

            {isStudentLoading && (
              <div className="overlay">
                <div
                  className="aui-table-page-loader"
                  role="alert"
                  aria-label="Page is Loading"
                >
                  <span className="sr-only">Page is Loading</span>
                </div>
              </div>
            )}

            {!isStudentTableLoading ? (
              <aui-table 
                type="default" 
                headerbackground={true} 
                headerborder={true}
              >
                <table className="studentTable">
                  <thead>
                    <tr>
                      {showCheckboxColumn && (
                        <th scope="col" className="checkboRow">
                          <div className="aui-th studentsCheckbox">
                            <div className="form-group form-check mb-0">
                              {students.map((student: any, index: number) => (
                                <input
                                  key={student.id || index}
                                  type="checkbox"
                                  id="primary-checkbox"
                                  checked={areAllStudentsSelected}
                                  onChange={(event: any) =>
                                    handleStudentMultiSelection(
                                      event.target.checked
                                    )
                                  }
                                  disabled={isAllDisabled}
                                />
                              ))}
                              <label htmlFor="primary-checkbox">
                                <span className="sr-only">Select all</span>
                              </label>
                            </div>
                          </div>
                        </th>
                      )}
                      <th scope="col">
                        <div className="aui-th">Full Name</div>
                      </th>
                      <th scope="col">
                        <div className="aui-th">Email</div>
                      </th>
                      <th scope="col">
                        <div className="aui-th">Primary Workplace</div>
                      </th>
                      <th scope="col">
                        <div className="aui-th">Cadre</div>
                      </th>
                      {showAttendanceColumn && (
                        <th scope="col">
                          <div className="aui-th">Certificate of Attendance</div>
                        </th>
                      )}
                      {showCompletionColumn && (
                        <th scope="col">
                          <div className="aui-th">Certificate of Completion</div>
                        </th>
                      )}
                      <th scope="col">
                        <div className="aui-th">Status</div>
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {students.map((student: any, index: number) => (
                      <tr key={`data-row-${student.id || index}`}>
                        {showCheckboxColumn && (
                          <td data-title="Selection">
                            <div className="aui-td">
                              <div className="form-group aui-checkbox-row text-left mb-0 form-check">
                                <input
                                  type="checkbox"
                                  className="select-students-chkbox"
                                  id={`primary-checkbox-${index}`}
                                  disabled={
                                          userRole ===
                                          AdminRoles.ApprovingAdmin 
                                              ? (!student?.trainingDetails[0]
                                                ?.isAttendanceCertificateGenerated 
                                                || student?.trainingDetails[0]?.completionCertificateGeneratedStatus === 'COMPLETED' ||
                                                student?.trainingDetails[0]?.completionCertificateGeneratedStatus === 'FAILED'
                                            ) 
                                            : false
                                  }
                                  checked={
                                    selectedStudents
                                      .map((student) => student.id)
                                      .includes(student.id) ||
                                    (userRole === AdminRoles.ApprovingAdmin &&
                                      ["COMPLETED", "FAILED"].includes(
                                        student?.trainingDetails[0]
                                          ?.completionCertificateGeneratedStatus
                                      ))
                                  }
                                  onChange={(event: any) =>
                                    handleStudentSelection(
                                      event.target.checked,
                                      student
                                    )
                                  }
                                />
                                <label
                                  htmlFor={`primary-checkbox-${index}`}
                                  aria-label={`Primary Checkbox ${index}`}
                                ></label>
                              </div>
                            </div>
                          </td>
                        )}
                        <td data-title="Full Name">
                          <div className="aui-td">
                            {student.firstName} {student.lastName}
                          </div>
                        </td>
                        <td data-title="Email">
                          <div className="aui-td">{student.email}</div>
                        </td>
                        <td data-title="Primary Workplace">
                          <div className="aui-td">{student.hospitalName}</div>
                        </td>
                        <td data-title="Cadre">
                          <div className="aui-td">{student.cadreName}</div>
                        </td>
                        {showAttendanceColumn && (
                          <td data-title="Certificate of Attendance">
                            <div className="aui-td">
                              <TableStatus
                                status={
                                  student?.trainingDetails?.[0]
                                    ?.isAttendanceCertificateGenerated
                                    ? "GENERATED"
                                    : ("NOT_GENERATED" as SessionStatusTypes)
                                }
                              />
                            </div>
                          </td>
                        )}
                        {showCompletionColumn && (
                          <td data-title="Certificate of Completion">
                            <div className="aui-td">
                              <TableStatus
                                status={
                                  completionStatusMapper[
                                    student?.trainingDetails?.[0]
                                      ?.completionCertificateGeneratedStatus
                                  ] as SessionStatusTypes
                                }
                              />
                            </div>
                          </td>
                        )}
                        <td data-title="Status">
                          <div className="aui-td">
                            <span className="status-tag">
                              {codeToTextMapper[student.roleCode]}
                            </span>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </aui-table>
            ) : (
              <div className="aui-loader">
                <aui-loader type="content"></aui-loader>
              </div>
            )}

          
            <div className="mt-3">
              {students.length > 0 && (
                <section className="pagination py-3 secPagination">
                  <div className="w-100">
                    <AuiPrimaryPagination
                      inputdata={pagination}
                      totalitems={pagination.totalItems}
                      rowsperpage={pagination.rowsperpage}
                      setCurrentPage={setCurrentPage}
                      setPageSize={handlePageSizeChange}
                    />
                  </div>
                </section>
              )}
            </div>

            
            {showAttendanceActions && (
              <div className="cert-option-container justify-content-md-end">
                <MoreOption
                  btnClass={`btn btn-secondary studentControlsBtn ${
                    !selectedStudents.length || isLoading ? "disabled" : ""
                  }`}
                  customIcon="arrowdown"
                  mainButtonLabel="Certificate of Attendance"
                  disabled={!selectedStudents.length || isLoading}
                >
                  <ul>
                    <li tabIndex={-1}>
                      <button className="btn disabled">
                        <span className="mr-2">
                          <AuiIcon
                            iconClass="arrowright"
                            svgwidth="15"
                            svgheight="15"
                          ></AuiIcon>
                        </span>{" "}
                        Send certificate
                      </button>
                    </li>
                    <li>
                      {isViewLoading ? (
                        <button className="btn">
                          <span className="mr-2">
                            <AuiIcon
                              iconClass="download"
                              svgwidth="15"
                              svgheight="15"
                            ></AuiIcon>
                          </span>{" "}
                          Download certificate
                        </button>
                      ) : (
                        <button
                          className="btn"
                          onClick={() => fetchAttendanceCertificate("Cert_A")}
                        >
                          <span className="mr-2">
                            <AuiIcon
                              iconClass="download"
                              svgwidth="15"
                              svgheight="15"
                            ></AuiIcon>
                          </span>{" "}
                          Download certificate
                        </button>
                      )}
                    </li>
                  </ul>
                </MoreOption>

                <span className="mt-lg-0">
                  <MoreOption
                    btnClass={`btn btn-secondary studentControlsBtn ${
                      !selectedStudents.length ||
                      selectedInstanceData?.status !== "COMPLETED"
                        ? "disabled"
                        : ""
                    }`}
                    customIcon="arrowdown"
                    mainButtonLabel="Certificate of Completion"
                    disabled={
                      !selectedStudents.length ||
                      selectedInstanceData?.status !== "COMPLETED" ||
                      isLoading
                    }
                  >
                    <ul>
                      <li>
                        <button className="btn disabled">
                          <span className="mr-2">
                            <AuiIcon
                              iconClass="arrowright"
                              svgwidth="15"
                              svgheight="15"
                            ></AuiIcon>
                          </span>{" "}
                          Send certificate
                        </button>
                      </li>
                      <li>
                        <button
                          className="btn"
                          onClick={() => fetchAttendanceCertificate("Cert_C")}
                        >
                          <span className="mr-2">
                            <AuiIcon
                              iconClass="download"
                              svgwidth="15"
                              svgheight="15"
                            ></AuiIcon>
                          </span>{" "}
                          Download certificate
                        </button>
                      </li>
                    </ul>
                  </MoreOption>
                </span>
              </div>
            )}

            {showApprovingAdminActions && (
              <div className="d-flex flex-column flex-md-row justify-content-end mb-3">
                <AuiButton
                  variant="secondary"
                  buttontitle="Mark as Failed"
                  modalid="generateFailedCertificate"
                  buttonid="generateFailedCertificate"
                  buttonClick={() => markEligibleStudents("FAILED")}
                  size="medium"
                  loading={isStudCertificateLoading}
                  disabled={!selectedStudents.length}
                  buttonclass="mr-3 btn-student-fail mb-2"
                />
                <AuiButton
                  variant="primary"
                  buttontitle="Generate Completion Certificate"
                  modalid="generateCompletionCertificate"
                  buttonid="generateCompletionCertificate"
                  size="medium"
                  buttonClick={() => markEligibleStudents("COMPLETED")}
                  loading={isCertificateCertLoading}
                  disabled={!selectedStudents.length}
                />
              </div>
            )}
          </div>
        </div>
      </fieldset>
    );
  };
  
  const replacePlaceholders = (statusInfo: string)=> {
    if (statusInfo.includes("{courseType}")) {
      const approvedTrainingType = checkApprovedInstance();
      if (approvedTrainingType) {
        statusInfo = statusInfo.replace(/{courseType}/g, approvedTrainingType);
      }
    }
  
    if (statusInfo.includes("{status}") && trainingSession?.status) {
      let formattedStatus = formatStatus(trainingSession.status);
      statusInfo = statusInfo.replace(/{status}/g, formattedStatus);
    }
  
    if (statusInfo.includes("{approvingOrgName}") && trainingSession?.approvingOrgName) {
      statusInfo = statusInfo.replace(/{approvingOrgName}/g, trainingSession.approvingOrgName);
    }
  
    return statusInfo;
  }

  const formatStatus = (status: string)=> {
    if (status === "INPROGRESS") return "In Progress";
    if (status === "APPROVED") return status.toLowerCase();
    return status;
  }
  
  const handleInProgressStatus = (statusInfo: string) => {
    if (trainingSession?.status === "INPROGRESS") {
      statusInfo = statusInfo.replace("add or", "");
    }
    const typeCode = trainingSession?.trainingTypeCode;
    if (
      (typeCode === "BEC" || typeCode === "BEC TOT") &&
      showSendReminder() &&
      isApprovalRole &&
      firstInstance?.status === "INPROGRESS"
    ) {
      const feedbackMessage = firstInstance?.feedBackMessage;
      return feedbackMessage?.replace("Send Reminder", "") ?? statusInfo;
    }
    if (
      (typeCode === "BEC" || typeCode === "BEC TOT") &&
      firstInstance?.feedbackReminderMessage !== "" &&
      !isApprovalRole &&
      firstInstance?.status === "INPROGRESS"
    ) {
      const feedbackMessage = firstInstance?.feedbackReminderMessage;
      return feedbackMessage ?? statusInfo;
    }
    return statusInfo;
  };

  const hasFeedbackReminderMessage = () => {
    return trainingSession?.trainingInstance?.some(
      (instance: { feedbackReminderMessage: any }) =>
        !!instance.feedbackReminderMessage
    );
  };

  const getFeedbackReminderMessage = () => {
    return (
      trainingSession?.trainingInstance?.find(
        (instance: { feedbackReminderMessage: any }) =>
          instance.feedbackReminderMessage
      )?.feedbackReminderMessage || ""
    );
  };

  const handleSearchChange = (e: any) => {
    const value = e?.detail?.value || e?.target?.value || "";
    setSearchQuery(value);
  };
  const handleClearFacilitator = (e: any) => {
    setSearchQuery('');
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }
  useEffect(() => {
    if (!trainingSession?.trainingSessionTrainer) return;
  
    const query = searchQuery.trim().toLowerCase();
  
    if (!query) {
      setFilteredTrainers(trainingSession.trainingSessionTrainer);
      return;
    }
  
    const filtered = trainingSession.trainingSessionTrainer.filter((trainer: any) => {
      const fullName = `${trainer.firstName || ""} ${trainer.lastName || ""}`.toLowerCase();
      const email = (trainer.email || "").toLowerCase();
      const role = (codeToTextMapper[trainer.trainerType] || "").toLowerCase();
  
      const match =
        fullName.includes(query) ||
        email.includes(query) ||
        role.includes(query);
  
      return match;
    });
    
    setFilteredTrainers(filtered);
    
  }, [searchQuery, trainingSession?.trainingSessionTrainer]);

  const getTotalColumns = () => {
    let columnCount = 4;
    if ([AdminRoles.SponsoringAdmin, AdminRoles.MasterTrainer, AdminRoles.ApprovingAdmin].includes(userRole as AdminRoles) && selectedInstanceData?.status === "COMPLETED") columnCount++;
    if ([AdminRoles.SponsoringAdmin, AdminRoles.MasterTrainer].includes(userRole as AdminRoles) &&
    trainingSession?.status === "COMPLETED") columnCount++;
    return columnCount;
  };

function generateFileName(originalFileName: string | string[]) {
  const lastDotIndex = originalFileName.lastIndexOf(".");
  const now = new Date();
  const pad = (num: number, size = 2) => String(num).padStart(size, "0");
  const formattedTime = `${pad(now.getUTCMonth() + 1)}-${pad(
    now.getUTCDate()
  )}-${now.getUTCFullYear()}_${pad(now.getUTCHours())}_${pad(
    now.getUTCMinutes()
  )}_${pad(now.getUTCSeconds())}.${pad(now.getUTCMilliseconds(), 3)}`;

  if (lastDotIndex !== -1) {
    const baseName = originalFileName.slice(0, lastDotIndex);
    const extension = originalFileName.slice(lastDotIndex + 1);
    return `${baseName}_${formattedTime}.${extension}`;
  }

  return `${originalFileName}_${formattedTime}`;
}

 const exportTrainer = async () => {
   try {
     const response = await getTrainerExportList(
       sessionId,
       selectedInstanceData?.id,
       searchQuery,
     );

     const url = response?.data?.exportTrainers?.url;

     if (response?.status == "200" && url) {
       window.open(url, "_self");
     }
   } catch (error) {
     console.error("Error fetching trainer list:", error);
   }
 };

const exportStudent = async () => {
  try {
    const response = await getStudentExportList(
      sessionId,
      selectedInstanceData?.id
    );
    const url = response?.data?.Data?.url;

    if (response?.status == "200" && url) {
      window.open(url, "_self");
    }
  } catch (error) {
    console.error("Error fetching student list:", error);
  }
};
  
const isAllDisabled = useMemo(() => {
  if (userRole !== AdminRoles.ApprovingAdmin) return false;
  return students.every(
    (student) =>
      !student?.trainingDetails?.[0]?.isAttendanceCertificateGenerated ||
      student?.trainingDetails?.[0]?.completionCertificateGeneratedStatus ===
        "COMPLETED" ||
      student?.trainingDetails?.[0]?.completionCertificateGeneratedStatus ===
        "FAILED"
  );
}, [userRole, students]);

  return (
    <main className="courseView mt-3">
      {isViewLoading ? (
        <div className="aui-loader loaderHeight">
          <aui-loader type="content"></aui-loader>
        </div>
      ) : (
        <div className="container">
          <aui-breadcrumb
            previouspages='[{"title":"All Courses","url":"/course-listing"}]'
            currentpage={
              trainingSession?.trainingTypeCode
                ? `${trainingSession.trainingTypeCode} Course`
                : ""
            }
          ></aui-breadcrumb>
          <div className="d-flex align-items-center bordered mb-3 py-2">
            <Headings size="h1" className="pr-3 mb-0 font-400 h3">
              {trainingSession?.trainingTypeCode && (
                <>
                  {trainingSession.trainingTypeCode} Course{" "}
                  <span className="referIdCode">[{trainingSession.code}]</span>
                </>
              )}
            </Headings>
            {trainingSession?.status === "INPROGRESS" &&
              ["BEC", "BEC TOT"].includes(
                trainingSession?.trainingTypeCode
              ) && (
                <TableStatus
                  status={
                    getInstanceStatus(
                      trainingSession?.status
                    ) as SessionStatusTypes
                  }
                ></TableStatus>
              )}
          </div>
          <div>
            {trainingSession && !isViewLoading && (
              <div>
                {renderClassDetails()}
                {renderFileDetails()}
                {renderLocationDetails()}
                {isCourseTableLoading && (
                  <div className="overlay">
                    <div
                      className="aui-table-page-loader"
                      role="alert"
                      aria-label="Page is Loading"
                    >
                      <span className="sr-only">Page is Loading</span>
                    </div>
                  </div>
                )}
                <fieldset
                  className="row mb-5"
                  aria-labelledby="courseFacilator"
                >
                  <div className="col-12">
                    <div className="borderWrapped">
                      <div className="row d-flex justify-content-between align-items-center mt-2 mb-3">
                        <div className="col-12 col-md-8 pb-3 pb-md-0">
                          <div className="iconsColors">
                            <Headings
                              size="h2"
                              defaultClass="h8"
                              className={`blue mb-0`}
                              id="courseFacilator"
                            >
                              <aui-icon
                                block={false}
                                svgclass="aui-icon-survey"
                                pathclass="aui-path-survey"
                                icon="survey"
                                svgwidth="25"
                                svgheight="25"
                              ></aui-icon>{" "}
                              Course Facilitators
                            </Headings>
                          </div>
                        </div>
                        <div className="col-12 col-md-4 d-flex flex-wrap flex-md-nowrap align-items-center justify-content-end">
                          {filteredTrainers?.length > 0 && (
                            <div className="export me-3 mb-2 mb-md-0 flex-shrink-0">
                              <aui-icon
                                block={true}
                                svgclass="aui-icon-export"
                                pathclass="aui-path-export"
                                icon="export"
                                svgwidth="20"
                                svgheight="20"
                              />
                              <button
                                type="button"
                                className="export-text export-btn ml-1"
                                onClick={exportTrainer}
                              >
                                Export
                              </button>
                              <button className="tooltip mr-3">
                                <aui-icon
                                  svgclass="aui-icon-info"
                                  pathclass="aui-path-info"
                                  icon="info"
                                  svgwidth="18"
                                  svgheight="18"
                                />
                                <span className="tooltiptext">
                                  The export will include all data, along with
                                  additional fields.
                                </span>
                              </button>
                            </div>
                          )}
                          <div className="search-input-facilator flex-shrink-0 flex-grow-0">
                            <div className="d-flex align-items-center position-relative">
                              <span className="input-group-fac-text">
                                <AuiIcon iconClass="search" svgwidth="17" svgheight="17"></AuiIcon>
                              </span>
                              <input
                                ref={inputRef}
                                type="text"
                                value={searchQuery}
                                onChange={(event: any) => handleSearchChange(event)}
                                placeholder="Search by Name / Email / Role"
                                className="search-input"
                                aria-label="Search by Name, Email, or Role"
                              />
                            </div>
                            {searchQuery && (
                              <button
                                onClick={handleClearFacilitator}
                                className="clear-icon"
                                aria-label="Clear selected option"
                              >
                                <AuiIcon iconClass="closeIcon" svgwidth="12" svgheight="12"></AuiIcon>
                              </button>
                            )}
                            <div 
                              aria-live="assertive" 
                              aria-atomic="true"
                              className="visually-hidden-live-region"
                            >
                              {searchQuery && `${filteredTrainers?.length || 0} results`}
                            </div>
                        </div>
                      </div>
                    </div>
                    <aui-table
                      type="default"
                      headerbackground={true}
                      headerborder={true}
                    >
                    <div className="scrollable-container">
                      <table>
                        <thead>
                          <tr>
                            <th scope="col">
                              <div className="aui-th">Full Name</div>
                            </th>
                            <th scope="col">
                              <div className="aui-th">Email</div>
                            </th>
                            <th scope="col">
                              <div className="aui-th">Role</div>
                            </th>
                            <th scope="col">
                              <div className="aui-th">Cadre</div>
                            </th>
                            {[
                              AdminRoles.SponsoringAdmin,
                              AdminRoles.MasterTrainer,
                              AdminRoles.ApprovingAdmin,
                            ].includes(userRole as AdminRoles) &&
                              selectedInstanceData?.status === "COMPLETED" && (
                                <th scope="col">
                                  <div className="aui-th">
                                    Uploaded Documents
                                  </div>
                                </th>
                              )}
                            {[
                              AdminRoles.SponsoringAdmin,
                              AdminRoles.MasterTrainer,
                            ].includes(userRole as AdminRoles) && 
                            trainingSession?.status === "COMPLETED" && (
                              <th scope="col">
                                <div className="aui-th text-center">
                                  Actions
                                </div>
                              </th>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                        {filteredTrainers?.map((trainer: any, index: number) => (
                          <tr key={trainer?.email || index}>
                              <td data-title="Full Name">
                                <div className="aui-td">
                                  {trainer?.firstName} {trainer?.lastName}
                                </div>
                              </td>
                              <td data-title="Email">
                                <div className="aui-td">{trainer?.email}</div>
                              </td>
                              <td data-title="Role">
                                <div className="aui-td">
                                  {codeToTextMapper[trainer?.trainerType]}
                                </div>
                              </td>
                              <td data-title="Cadre">
                                <div className="aui-td">                             
                                  {trainer?.cadreName}                            
                                </div>
                              </td>
                              {[
                                AdminRoles.SponsoringAdmin,
                                AdminRoles.MasterTrainer,
                                AdminRoles.ApprovingAdmin,
                              ].includes(userRole as AdminRoles) &&
                                selectedInstanceData?.status ===
                                  "COMPLETED" && (
                                    <td data-title="Uploaded Documents">
                                    {
                                      trainer?.hasFeedbackDocuments ? (
                                        <div className="aui-td downloadDocFac">
                                          <Modals
                                            modalButtonTitle="View & Download"
                                            modalsize="auimodal-lg"
                                            headingAlign="left"
                                            buttonTitle="Close"
                                            modalTitle="Uploaded Documents"
                                            footerAlign="right"
                                            modalid={`uploadedFeedbackModal-${trainer?.trainerId}`}
                                            variant="button-text-styled"
                                            onModalOpen={() =>
                                              displayFeedbackDocumentList(trainer?.trainerId)
                                            }
                                            resetModal={handleResetDocumentModal}
                                            key={refreshKey}
                                          >
                                            {isLoading && (
                                              <div className="aui-loader">
                                                <aui-loader type="content"></aui-loader>
                                              </div>
                                            )}
                                            {feedBackDocumentList?.length >
                                              0 && (
                                              <div className="mb-3 uploadedDocsTable">
                                                <aui-table
                                                  type="default"
                                                  headerbackground={true}
                                                  headerborder={true}
                                                >
                                                  <table>
                                                    <thead>
                                                      <tr>
                                                        <th scope="col">
                                                          <div className="aui-th">
                                                            Date
                                                          </div>
                                                        </th>
                                                        <th
                                                          scope="col"
                                                          className="docsFileName"
                                                        >
                                                          <div className="aui-th">
                                                            File Name
                                                          </div>
                                                        </th>
                                                        <th scope="col">
                                                          <div className="aui-th">
                                                            Action
                                                          </div>
                                                        </th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      {feedBackDocumentList?.map(
                                                        (document, index) => (
                                                          <tr
                                                            key={
                                                              document.id || index
                                                            }
                                                          >
                                                            <td data-title="Date">
                                                              <div className="aui-td">
                                                                {formatDocCreatedDate(document?.createdAt)}
                                                              </div>
                                                            </td>
                                                            <td data-title="File Name">
                                                              <div className="aui-td">
                                                                {
                                                                  document?.filepath
                                                                }
                                                              </div>
                                                            </td>
                                                            <td data-title="Action">
                                                              <div className="aui-td">
                                                                <AuiButton
                                                                  variant="read-more"
                                                                  buttontitle="Download"
                                                                  buttonid={`downloadDoc-${
                                                                    document.id ||
                                                                    index
                                                                  }`}
                                                                  size="small"
                                                                  onClick={() =>
                                                                    downloadFeedbackDocument(
                                                                      document.documentUrl,
                                                                      document.filepath
                                                                        .split(
                                                                          "/"
                                                                        )
                                                                        .pop()
                                                                    )
                                                                  }
                                                                ></AuiButton>
                                                              </div>
                                                            </td>
                                                          </tr>
                                                        )
                                                      )}
                                                    </tbody>
                                                  </table>
                                                </aui-table>
                                              </div>
                                            )}
                                             <div className="mt-3">
                                              {feedBackDocumentList.length > 0 && (
                                                <section className="pagination py-3 secPagination">
                                                  <div className="w-100">
                                                    <AuiPrimaryPagination
                                                      inputdata={
                                                        modalPagination
                                                      }
                                                      totalitems={
                                                        modalPagination.totalItems
                                                      }
                                                      rowsperpage={
                                                        modalPagination.rowsperpage
                                                      }
                                                      setCurrentPage={
                                                        setModalCurrentPage
                                                      }
                                                      setPageSize={handleModalPageSizeChange}
                                                    />
                                                  </div>
                                                </section>
                                              ) }
                                            </div>
                                          </Modals>
                                        </div>
                                      ) : (
                                        <p>No Documents Uploaded</p>
                                      )
                                    }
                                  </td>
                                )}
                              {[
                                AdminRoles.SponsoringAdmin,
                                AdminRoles.MasterTrainer,
                              ].includes(userRole as AdminRoles) && 
                              trainingSession?.status === "COMPLETED" && (
                                <td data-title="Actions">
                                  <div className="aui-td">
                                    <MoreOption
                                      ariaLabel="moreOptions"
                                      className="text-lg-center"
                                    >
                                      <ul>
                                        <li>
                                          {FacilitatorHierarchy[
                                            trainer?.trainerType
                                          ] && (
                                            <button
                                              className="btn"
                                              onClick={() =>
                                                promoteTrainer(
                                                  trainer?.trainerId,
                                                  trainer?.trainerType
                                                )
                                              }
                                            >
                                              <span className="d-flex align-items-center">
                                                <aui-icon
                                                  svgclass="aui-icon-star"
                                                  pathclass="aui-path-star"
                                                  icon="star"
                                                  svgwidth="15"
                                                  svgheight="15"
                                                ></aui-icon>
                                                <span className="ml-2">
                                                  Promote to{" "}
                                                  {
                                                    FacilitatorHierarchy[
                                                      trainer?.trainerType
                                                    ]
                                                  }
                                                </span>
                                              </span>
                                            </button>
                                          )}
                                        </li>
                                        <li tabIndex={-1}>
                                          <button className="btn disabled" tabIndex={-1}>
                                              <span className="d-flex align-items-center">
                                              <aui-icon
                                                svgclass="aui-icon-arrowright"
                                                pathclass="aui-path-arrowright"
                                                icon="arrowright"
                                                svgwidth="15"
                                                svgheight="15"
                                                fillcolor="#00000"
                                              ></aui-icon>
                                                <span className="ml-2">
                                                Send Certificate
                                                </span>
                                              </span>
                                          </button>
                                        </li>
                                        <li tabIndex={-1}>
                                            <button className="btn disabled" tabIndex={-1}>
                                              <span className="d-flex align-items-center">
                                                <aui-icon
                                                  svgclass="aui-icon-download"
                                                  pathclass="aui-path-download"
                                                  icon="download"
                                                  svgwidth="15"
                                                  svgheight="15"
                                                  fillcolor="#00000"
                                                  className="pr-2 downloadIcon"
                                                ></aui-icon>
                                                <span className="ml-2">
                                                Download Certificate
                                                </span>
                                              </span>
                                            </button>
                                          </li>
                                        {
                                          trainer?.trainerType !== "MASTER_TRAINER" && (
                                            <li>
                                              <AuiButton
                                                variant="button-text-styled"
                                                buttontitle="Upload Document"
                                                modalid="exampleModal"
                                                size="small"
                                                buttonid={""}
                                                buttonclass="actionBtn"
                                                ifmodal={true}
                                                data-backdrop="static"
                                                data-keyboard="false"
                                                buttonClick={() => handleUploadDocument(trainer?.trainerId)}
                                              >
                                                <span className="pr-2">
                                                  <AuiIcon iconClass="fileupload" svgheight="15" svgwidth="15" />
                                                </span>
                                              </AuiButton>
                                            </li>
                                          )
                                        }
                                      </ul>
                                    </MoreOption>
                                    {modals[trainer.trainerId] && (
                                      <AuiConfirmationModal
                                        modalType="upload-modal"
                                        modalsize="auimodal-md"
                                        title="Upload Supported Documents"
                                        disableActionButton={false}
                                        buttontitle="Upload"
                                        alertText="Test alert text."
                                        handleConfirmationClick={() => facilitatorFeedbackUpload(trainer?.trainerId)}
                                        close={() => handleCancelUploadDoc(trainer?.trainerId)}
                                        uploadedFiles={uploadedFiles}
                                        setUploadedFiles={setUploadedFiles}
                                        resetModal={resetFileUploadState}
                                        key={refreshKey}
                                        auiFileUploadProps={{
                                          allowedfiletypes: ".pdf",
                                          maxuploadsize: 5000000,
                                          iseditable: false,
                                          fileuploadlabel: true,
                                          auifiluploaddirection: "column",
                                          auifiluploaderrorstate: false,
                                          auifiluploadrequired: true,
                                          auifiluploadrequiredmessage:
                                            "Upload files should be mandatory",
                                          auifileuploaderrormessage: "Please upload the correct format",
                                          onChange: handleFileChange,
                                        }}
                                      />
                                    )}
                                  </div>
                                </td>
                              )}
                          </tr>
                        ))}
                        {filteredTrainers?.length === 0 && (
                          <tr aria-live="polite">
                            <td colSpan={getTotalColumns()}>
                              <div className="aui-td text-center"
                                aria-live="polite"
                                aria-atomic="true"
                              >No results found.</div>
                            </td>
                          </tr>
                        )}
                        </tbody>
                      </table>
                    </div>  
                    </aui-table>
                  </div>
                </div>
              </fieldset>
              {renderCollaborationDetails()}

              {renderClassTypeToggle()}

              {renderBECClassInfo()}

              {renderBECTOTClassInfo()}

              {renderStudentDetails()}

                <div className="d-flex flex-column flex-md-row justify-content-between align-items-start my-5 px-3 px-md-0">
                  <div className="col-12 col-md-4 p-0 d-flex align-items-start mb-3 mb-md-0">
                    <span className="backButton">
                      <aui-icon
                        icon="arrowleft"
                        svgwidth="21"
                        svgheight="21"
                      ></aui-icon>
                      <AuiButton
                        variant="general-text-link"
                        buttontitle="Back"
                        buttonid=""
                        modalid="exampleModal"
                        size="large"
                        anchorlinkurl=""
                        buttonclass="customClasstest"
                        buttonClick={handleBackButton}
                      ></AuiButton>
                    </span>
                  </div>
                  <div className="col-12 col-md-8 d-flex flex-column flex-md-row justify-content-end align-items-start p-0 flex-wrap">
                    {hasApproveAccess &&
                      trainingSession?.status === "PENDING" &&
                      selectedInstanceData?.id ===
                        trainingSession?.trainingInstance?.[0]?.id && (
                        <>
                          <span className="mr-3">
                            <Modals
                              id="rejectNote"
                              modalButtonTitle="Reject"
                              modalsize="auimodal-sm"
                              headingAlign="left"
                              modalTitle="Reject Course"
                              footerAlign="right"
                              buttonTitle="Reject"
                              modalid="rejectModal"
                              variant="secondary"
                              action={() => sendStatusUpdateRequest("REJECTED")}
                              modalType="input-modal"
                              resetModal={handleResetNoteModal}
                              key={refreshKey}
                            ></Modals>
                          </span>
                            <Modals
                              modalButtonTitle="Approve"
                              modalsize="auimodal-sm"
                              headingAlign="center"
                              modalTitle="Approve Course"
                              footerAlign="right"
                              buttonTitle="Approve"
                              modalid="approveModal"
                              variant="primary"
                              action={() => sendStatusUpdateRequest("APPROVED")}
                            >
                              <p className="text-center font-400 h8 pb-2">
                                Ensure the concept note for this course includes
                                all the mandatory topics for BEC.
                              </p>
                            </Modals>
                        </>
                      )}
                    {showEditButton() && (
                        <AuiButton
                          variant={
                            ["DRAFT", "PENDING", "REJECTED"].includes(
                              trainingSession?.status
                            )
                              ? "primary"
                              : "secondary"
                          }
                          buttontitle="Edit"
                          modalid="exampleModal"
                          buttonid={""}
                          size="medium"
                          buttonClick={navigateToEdit}
                        ></AuiButton>
                    )}
                    {[
                      AdminRoles.SponsoringAdmin,
                      AdminRoles.MasterTrainer,
                    ].includes(userRole as AdminRoles) &&
                      selectedInstanceData?.status === "INPROGRESS" &&
                      !documentIds[selectedInstanceData?.index] && (
                        <div className="workbook-section-container">
                          <div className="workbook-info-section">
                            <div className="d-flex align-items-center download-row">
                              <img src={Excel} alt="" width="24" height="24"/>
                              <AuiButton
                                variant="read-more"
                                size="medium"
                                buttontitle="Download course coordinator workbook template"
                                arialabel="Download course coordinator workbook Template"
                                buttonid="downloadTemplateId"
                                buttonclass="ms-2 font-600 feedback-template-btn"
                                buttonClick={getFeedbackTemplate}
                              ></AuiButton>
                            </div>
                            <div className="d-flex align-items-center mt-2 more-info-container">
                              <div className="info me-2">
                                <aui-icon
                                  svgclass="aui-icon-info me-1"
                                  pathclass="aui-path-info"
                                  icon="info"
                                  svgwidth="18"
                                  svgheight="18"
                                />
                              </div>
                              <CommonModal
                                buttonTitle="More Info >"
                                title="Course Coordinator Workbook"
                                modalId="courseWorkbookModal"
                                modalsize="auimodal-md"
                                showCloseButton={true}
                              >
                                <p className="mb-3">
                                  Once your course has finalized, please return
                                  to this section and upload a copy of the
                                  course coordinator workbook. This will allow
                                  us to follow progress among courses and
                                  concentrate information.
                                </p>
                                <p className="mb-3">
                                  Please make sure all tabs are updated and in
                                  line with your course.
                                </p>
                                <p className="mb-2">
                                  We ask you to pay attention specifically to
                                  the following tabs:
                                </p>
                                <ul className="pl-4 mb-0">
                                  <li>
                                    Schedule (ensure it confirms the schedule
                                    you used),
                                  </li>
                                  <li>
                                    Participant tracker (participants’ scores
                                    and course outcome should be complete on
                                    this tab),
                                  </li>
                                  <li>
                                    Course report (ensure it's complete and data
                                    is accurate).
                                  </li>
                                </ul>
                              </CommonModal>
                            </div>
                          </div>

                          <div className="workbook-upload-section">
                            <Modals
                              modalButtonTitle="Upload course coordinator workbook"
                              modalType="upload-modal"
                              modalsize="auimodal-md"
                              headingAlign="left"
                              modalTitle="Upload course coordinator workbook"
                              footerAlign="right"
                              buttonTitle="Upload"
                              modalid="fuploadFeedbackModal"
                              variant="primary"
                              action={handleFeedbackSubmit}
                              disableActionButton={!feedbackBtnEnable}
                              resetModal={resetFileUploadState}
                              key={refreshKey}
                              uploadedFiles={uploadedFiles}
                              setUploadedFiles={setUploadedFiles}
                              auiFileUploadProps={{
                                allowedfiletypes: ".xls, .xlsx",
                                maxuploadsize: 5242880,
                                iseditable: false,
                                fileuploadlabel: true,
                                auifiluploaddirection: "column",
                                auifiluploaderrorstate: false,
                                auifiluploadrequired: true,
                                auifiluploadrequiredmessage:
                                  "Upload files should be mandatory",
                                auifileuploaderrormessage:
                                  "Please upload the correct format",
                                fileuploadlabeltext:
                                  "Upload course coordinator workbook",
                                onChange: handleFileChange,
                              }}
                            />
                          </div>
                        </div>
                      )}
                    {userRole === "Approving Org Admin" &&
                      selectedInstanceData?.status === "INPROGRESS" &&
                      !selectedInstanceData?.isFeedbackApproved &&
                      !!documentIds[selectedInstanceData?.index] && (
                        <AuiButton
                          variant="primary"
                          buttontitle="Approve course coordinator workbook"
                          modalid="approveModal"
                          buttonid={""}
                          size="medium"
                          buttonClick={approveFeedback}
                          loading={isApproveFeedbackLoading}
                        />
                      )}
                    {showFinalizeRosterButton() && (
                      <span className="ml-3">
                        <Modals
                          modalButtonTitle="Finalize Roster"
                          modalsize="auimodal-sm"
                          headingAlign="center"
                          modalTitle="Finalize Student Roster"
                          footerAlign="right"
                          buttonTitle="Finalize Roster"
                          modalid="finalizeRosterModal"
                          variant="primary"
                          action={() => handleFinalizeRoster()}
                          disableActionButton={!enableRoster}
                        >
                          <p className="text-center font-400 h8 pb-2">
                            NOTE: Once the roster is finalized, you cannot edit
                            any student details.
                          </p>
                        </Modals>
                      </span>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </main>
  );
};

export default ViewCourse;
